<template>
    <div>
        <component
            :is="component"
            v-for="(offer, index) in offers"
            :key="offer.offerKey"
            :offer="offer"
            :data-cy="`flight-offer-${index}`"
        >
            <template v-slot:price>
                <slot name="price" :offer="offer" />
            </template>
        </component>
        <flight-price-detail-modal />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import FlightPriceDetailModal from '~/components/parts/Flights/FlightPriceDetailModal.vue'
    import FlightCard from '~/components/flights/search/offers/FlightCard.vue'

    @Component({
        components: {
            FlightCard,
            FlightPriceDetailModal,
        },
    })
    export class FlightOffers extends Vue {
        @Prop({required: true}) offers

        get component() {
            return !this.$breakpoint.smAndDown ? resolveComponent('FlightCard') : resolveComponent('FlightCard')
        }
    }

    export default FlightOffers
</script>
